import { Component, OnInit, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArrayName } from '@angular/forms';
import { Gender, ResidenceItem, QuotationModule, QuotationDetail } from '../services/domain.service';
import { QuotationsService } from '../services/quotations.service';
import { GlobalsService } from '../services/globals.service';
import { Router } from '@angular/router';
import { StudentType } from '../services/enums.service';
import { of } from 'rxjs';
import { DataService } from '../services/data.service';
import { MatTableDataSource } from '@angular/material';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.less']
})
export class ConfirmationComponent implements OnInit {
  labelFloat: string = "always";
  checked: boolean = false;
  selectedGender: string = "";
  canIncludeRes: boolean = true;
  showResSelect: boolean = false;
  degreeFullName: string = "";

  quotationDetail: QuotationDetail = { studentType: StudentType.local, academicYear: 0, degreeTypeId: "",    degreeTypeName: "", 
      gradTypeId: "", gradTypeName: "", studyTypeId: "", studyTypeName: "", facultyId: "", facultyName: "", programmeId: 0, 
      programmeName: "", streamId: "", streamName: "", yearLevelId: 0, yearLevelName: "", quotationsModules: [], programmeDuration: 0, chargeByModule: true, programmeCost: 0,
      includeRes: false, generateQuotation: false, generateProforma: false, residence: undefined, personalInfo: undefined, proformaInfo: undefined };

  quotationModules: Array<QuotationModule> = [];
  coreModules: Array<QuotationModule> = [];
  electiveModules: Array<QuotationModule> = [];
  residences: Array<ResidenceItem> = [];
  selectedRes: ResidenceItem = undefined;

  subTotalItems: Array<SubTotalItem> = [];
  subtotalDataSource: MatTableDataSource<SubTotalItem>;

  totalItems: Array<SubTotalItem> = [];
  totalDataSource: MatTableDataSource<SubTotalItem>;

  chargeByModule: boolean = true;
  programmeCost: number = 0;

  displayedModuleColumns: string[] = ['moduleCode', 'moduleName', 'moduleCost', 'moduleCredits'];
  displayedSubTotalColumn: string[] = ['description', 'amount', 'credits'];
  displayedResColumns: string[] = ['roomTypeId', 'resSelect', 'roomTypeName', 'maxPrice', 'placeHolder'];

  constructor(private service: QuotationsService,
    private globals: GlobalsService,
    private router: Router,
    private data: DataService,
    private notifier: SnotifyService) { }

  async ngOnInit() {
    if(window.innerWidth < 600) {
      this.labelFloat = "auto";
    }

    this.data.changePage("summary");

    this.subtotalDataSource = new MatTableDataSource([]);
    this.totalDataSource = new MatTableDataSource([]);

    if(this.globals.quotationDetail) {
      this.quotationDetail = this.globals.quotationDetail;
      
      if(this.quotationDetail) {
        this.chargeByModule = this.quotationDetail.chargeByModule;
        this.programmeCost = this.quotationDetail.programmeCost;
        this.degreeFullName = this.quotationDetail.programmeName;
        if(this.degreeFullName != "" && this.quotationDetail.streamName && this.quotationDetail.streamName != "") {
          this.degreeFullName = this.degreeFullName.concat(" (", this.quotationDetail.streamName, ")");
        }
      }
    }
    
    if(this.globals.quotationDetail && this.globals.quotationDetail.quotationsModules && this.globals.quotationDetail.quotationsModules.length > 0) {
      this.quotationModules = this.globals.quotationDetail.quotationsModules;

      let core: Array<QuotationModule> = []
      let elect: Array<QuotationModule> = [];
      this.globals.quotationDetail.quotationsModules.forEach(function(mod){
        if(mod.isCore){
          core.push(mod);
        } else {
          elect.push(mod);
        }
      });

      this.coreModules = core;
      this.electiveModules = elect;
    }

    let moduleFees: number = 0;
    let moduleCredits: number = 0;
    let registrationFee: SubTotalItem;
    let tuitionFees: SubTotalItem;

    this.quotationModules.forEach(m => {
      moduleFees += m.moduleCost;
      moduleCredits += m.moduleCredits
    });
    if(this.chargeByModule == false){
      moduleFees = this.programmeCost;
    }
    tuitionFees = { key: 'TUITION', description: 'Total tuition fees', amount: moduleFees, credits: moduleCredits.toString() };

    this.data.isLoading(true);
    this.service.getRegistrationFee().subscribe(fee =>{
      let regFee: number = fee as number;
      registrationFee = {key: 'REG', description: 'Registration fee', amount: regFee, credits: ''}

      this.subTotalItems.push(tuitionFees, registrationFee)
      
      if(this.quotationDetail.includeRes == true) {
        this.toggleResidenceSelection(true);
      }
      else {
        this.updateTotalCost().then(result => {
          this.subtotalDataSource = new MatTableDataSource([])
          this.subtotalDataSource.data = this.subTotalItems;

          this.totalDataSource = new MatTableDataSource([]);
          this.totalDataSource.data = this.totalItems;
        });
      }
    }, error => {
      this.data.isLoading(false);
      console.log('Error on getRegistrationFee(): ', error);
      this.showError('getRegistrationFee');
    }, () => {
      this.data.isLoading(false);
    });
  }

  toggleResidenceSelection(pageLoad: boolean) {
    this.showResSelect = !this.showResSelect;
    if(this.showResSelect == true){
      this.data.isLoading(true);
      this.service.getResidences(this.quotationDetail.academicYear, this.quotationDetail.facultyId, this.quotationDetail.gradTypeId, 
        this.quotationDetail.programmeDuration, this.quotationDetail.yearLevelId).subscribe(result => {
          console.log(this.quotationDetail); //Log quotation detail
          console.log(result);
          this.residences = result as Array<ResidenceItem>;
          if(this.residences.length > 0) this.canIncludeRes = true;
          else this.canIncludeRes = false;

          var validPrevResSelection: boolean = false;
          if(this.quotationDetail.residence){
            var prevRes = this.residences.find(res => res.roomTypeId == this.quotationDetail.residence.roomTypeId);
            if(prevRes){
              validPrevResSelection = true;
            }
          }

          //On page load, also check prev selected res
          if(pageLoad){
            if(validPrevResSelection){
              this.checked = true;
              this.residences.forEach(res => {
                if(res.roomTypeId == this.quotationDetail.residence.roomTypeId){
                  res.selected = true;
                }
              });
              this.resSelectionChange(this.quotationDetail.residence);
            }
            else {
              this.showResSelect = false;
              this.quotationDetail.includeRes = false;
              this.quotationDetail.residence = undefined;

              this.updateTotalCost().then(result => {
                this.subtotalDataSource = new MatTableDataSource([])
                this.subtotalDataSource.data = this.subTotalItems;
      
                this.totalDataSource = new MatTableDataSource([]);
                this.totalDataSource.data = this.totalItems;
              });
            }
          } else {
            if(this.residences && this.residences.length > 0){
              this.residences[0].selected = true;
              this.resSelectionChange(this.residences[0]);
            }
          }
        }, error => {
          this.data.isLoading(false);
          console.log('Error in toggleResidenceSelection(): ', error)
          this.showError('toggleResidenceSelection');
        }, () => {
          this.data.isLoading(false);
        });
    }

    if(this.showResSelect == false){
      this.removeCurrResSelection().then(result => {
        this.updateTotalCost().then(result => {
          this.subtotalDataSource = new MatTableDataSource([])
          this.subtotalDataSource.data = this.subTotalItems;

          this.totalDataSource = new MatTableDataSource([]);
          this.totalDataSource.data = this.totalItems;
        });
      });
    }
  }

  resSelectionChange(res: ResidenceItem){
    this.removeCurrResSelection().then(result =>{
      if(res){
        this.selectedRes = res;
        let residenceFee: SubTotalItem = {key: 'RES', description: res.roomTypeName, amount: res.maxPrice, credits: ''};

        this.subTotalItems.push(residenceFee)
        this.updateTotalCost().then(result => {
          this.subtotalDataSource = new MatTableDataSource([])
          this.subtotalDataSource.data = this.subTotalItems;

          this.totalDataSource = new MatTableDataSource([]);
          this.totalDataSource.data = this.totalItems;
        });
      }
    });
  }

  removeCurrResSelection(){
    let index: number = -1;
    let count: number = 0;

    //Remove previous res selection
    this.subTotalItems.forEach(item => {
      if(item.key == 'RES'){
        index = count;
      }
      count++;
    });

    if(index > -1) {
      this.subTotalItems.splice(index, 1);
    }

    //Remove total costs
    index = -1;
    count = 0;
    this.subTotalItems.forEach(item => {
      if(item.key == 'TOTAL'){
        index = count;
      }
      count++;
    });

    if(index > -1) {
      this.subTotalItems.splice(index, 1);
    }

    this.selectedRes = undefined;
    return of(null).toPromise()
  }

  updateTotalCost() {
    if(this.totalItems.length > 0) {
      //Remove all items in array
      this.totalItems.splice(0, this.totalItems.length);
    }

    let totalCost: SubTotalItem;
    let totalAmount: number = 0;
    this.subTotalItems.forEach(i => totalAmount += i.amount);
    totalCost = {key: 'TOTAL', description: 'Total', amount: totalAmount, credits: ''};
    //this.subTotalItems.push(totalCost)
    this.totalItems.push(totalCost);
    
    return of(null).toPromise();
  }

  proceed() {
    var formValid: boolean = true;

    if(this.quotationDetail) {
      this.quotationDetail.includeRes = this.showResSelect;

      if(this.quotationDetail.includeRes == true) {
        if(this.selectedRes){
          this.quotationDetail.residence = this.selectedRes;
        }
        else {
          this.notifier.warning("Please select accommodation option or uncheck 'Include University Residence'", {
            timeout: 0,
            position: SnotifyPosition.centerCenter,
            closeOnClick: false,
            buttons: [
              {text: 'Ok'}
            ]
          })
          formValid = false;
        }
      }
      else {
        this.quotationDetail.residence = undefined;
      }
    } else {
      formValid = false;
    }

    if(formValid){
      
      this.quotationDetail.quotationsModules = this.quotationModules;
      
      this.globals.quotationDetail = this.quotationDetail;
      this.router.navigate(['/default', {outlets: {'main': ['personalinfo']}}]);
    }
  }

  @HostListener('window:resize', ['$event']) 
  onResize(event){
    if(event.target.innerWidth < 600) {
      this.labelFloat = "auto";
    }
    else {
      this.labelFloat = "always";
    }
  }

  showError(source: string){
    this.notifier.error('An error occurred at ' + source + '. Please try again and if the problem persists, please contact support at servicedesk@uwc.ac.za', {
      timeout: 0,
      position: SnotifyPosition.centerCenter,
      closeOnClick: false,
      buttons: [
        {text: 'Ok'}
      ]
    });
  }
}

export interface SubTotalItem {
  key: string;
  description: string;
  amount: number;
  credits: string;
}
